{
  "seo": {
    "title": "БроньСРМ — бронирование ресурсов в amoCRM",
    "description": "Виджет для бронирования комнат, оборудования и переговорных прямо в amoCRM. Интеграция с календарём, уведомления в Telegram, автоматизация рабочих процессов.",
    "keywords": "бронирование amoCRM, виджет amoCRM, броньСРМ, резервирование ресурсов, календарь amoCRM",
    "canonicalPath": "/booker"
  },
  "hero": {
    "badge": "Интеграция с amoCRM",
    "title": "Визуальное **бронирование** встреч и ресурсов в **amoCRM**",
    "lead": "Бронируйте переговорные, инвентарь и встречи прямо из карточки сделки.",
    "text": "Никаких лишних вкладок — всё в одном месте. Установка за 5 минут, работа с первого дня.",
    "primaryCta": {
      "label": "Попробовать бесплатно",
      "href": "#contact"
    },
    "secondaryCta": {
      "label": "Как это работает",
      "href": "#how-it-works"
    },
    "stats": [
      {
        "value": "2 000+",
        "label": "Компаний используют",
        "gradient": "from-yellow-300 to-red-400"
      },
      {
        "value": "98%",
        "label": "Довольных клиентов",
        "gradient": "from-green-300 to-cyan-400"
      },
      {
        "value": "5 мин",
        "label": "Установка виджета",
        "gradient": "from-violet-400 to-pink-400"
      }
    ],
    "mockup": {
      "caption": "БроньСРМ — Бронирование",
      "month": "Апрель 2026",
      "weekdays": [
        "Пн",
        "Вт",
        "Ср",
        "Чт",
        "Пт",
        "Сб",
        "Вс"
      ],
      "slots": [
        {
          "time": "10:00",
          "title": "Встреча с клиентом",
          "gradient": "from-yellow-400/80 to-red-400/80",
          "icon": "ri-user-line"
        },
        {
          "time": "13:30",
          "title": "Переговорная А",
          "gradient": "from-green-400/80 to-cyan-400/80",
          "icon": "ri-building-line"
        },
        {
          "time": "16:00",
          "title": "Проектор #2",
          "gradient": "from-violet-500/80 to-pink-400/80",
          "icon": "ri-projector-line"
        }
      ]
    }
  },
  "features": {
    "badge": "Возможности",
    "title": "Всё для управления ресурсами",
    "subtitle": "Мощный инструмент бронирования, который органично встраивается в ваш рабочий процесс amoCRM",
    "items": [
      {
        "icon": "ri-calendar-check-line",
        "gradient": "from-yellow-300 via-orange-400 to-red-400",
        "bg": "from-yellow-100 to-red-100",
        "tag": "Интерактивный UI",
        "tagColor": "bg-yellow-50 text-yellow-700",
        "title": "Визуальный календарь",
        "desc": "Интерактивный drag-and-drop календарь прямо в amoCRM. Видите все брони в реальном времени без переключения между вкладками.",
        "tagColorDark": "dark:bg-yellow-500/[0.12] dark:text-yellow-300"
      },
      {
        "icon": "ri-building-4-line",
        "gradient": "from-green-400 via-teal-400 to-cyan-400",
        "bg": "from-green-100 to-cyan-100",
        "tag": "Автоматизация",
        "tagColor": "bg-green-50 text-green-700",
        "title": "Бронирование помещений",
        "desc": "Управляйте переговорными, офисами и залами. Настройте вместимость, оборудование и правила бронирования для каждого помещения.",
        "tagColorDark": "dark:bg-green-500/[0.12] dark:text-green-300"
      },
      {
        "icon": "ri-tools-line",
        "gradient": "from-violet-500 via-purple-400 to-pink-400",
        "bg": "from-violet-100 to-pink-100",
        "tag": "Контроль",
        "tagColor": "bg-violet-50 text-violet-700",
        "title": "Учёт инвентаря",
        "desc": "Проекторы, ноутбуки, транспорт — бронируйте любой инвентарь. Система предотвращает двойные брони автоматически.",
        "tagColorDark": "dark:bg-violet-500/[0.12] dark:text-violet-300"
      },
      {
        "icon": "ri-notification-3-line",
        "gradient": "from-cyan-400 via-blue-400 to-violet-500",
        "bg": "from-cyan-100 to-violet-100",
        "tag": "Уведомления",
        "tagColor": "bg-cyan-50 text-cyan-700",
        "title": "Умные уведомления",
        "desc": "Автоматические напоминания участникам встречи, уведомления об изменениях и подтверждения бронирования в один клик.",
        "tagColorDark": "dark:bg-cyan-500/[0.12] dark:text-cyan-300"
      },
      {
        "icon": "ri-link-m",
        "gradient": "from-red-400 via-pink-400 to-yellow-400",
        "bg": "from-red-100 to-yellow-100",
        "tag": "Интеграция",
        "tagColor": "bg-red-50 text-red-700",
        "title": "Связь со сделками",
        "desc": "Каждое бронирование привязывается к сделке, контакту или компании в amoCRM. Полная история взаимодействий в одном месте.",
        "tagColorDark": "dark:bg-red-500/[0.12] dark:text-red-300"
      },
      {
        "icon": "ri-bar-chart-2-line",
        "gradient": "from-green-400 via-yellow-300 to-orange-400",
        "bg": "from-green-100 to-orange-100",
        "tag": "Аналитика",
        "tagColor": "bg-orange-50 text-orange-700",
        "title": "Аналитика загрузки",
        "desc": "Отчёты по загруженности ресурсов, популярным временным слотам и эффективности использования помещений и инвентаря.",
        "tagColorDark": "dark:bg-orange-500/[0.12] dark:text-orange-300"
      }
    ]
  },
  "howItWorks": {
    "badge": "Как это работает",
    "title": "Три шага до первого бронирования",
    "subtitle": "Простая интеграция без разработчиков и сложных настроек",
    "steps": [
      {
        "num": "01",
        "title": "Установите виджет в amoCRM",
        "desc": "Перейдите в маркетплейс amoCRM, найдите БроньСРМ и нажмите «Установить». Настройка занимает не более 5 минут.",
        "icon": "ri-download-cloud-line",
        "step": 1,
        "reverse": false,
        "labelGradient": "from-yellow-400 to-red-400",
        "blobGradient": "from-yellow-500/30 via-red-500/25 to-pink-500/20",
        "image": "https://readdy.ai/api/search-image?query=amoCRM%20marketplace%20widget%20installation%20screen%20minimal%20dark%20interface%20clean%20modern%20UI%20mockup&width=1200&height=700&seq=bookerstep001&orientation=landscape"
      },
      {
        "num": "02",
        "title": "Настройте ресурсы и правила",
        "desc": "Добавьте переговорные, инвентарь и сотрудников. Задайте рабочие часы, вместимость и правила бронирования.",
        "icon": "ri-settings-4-line",
        "step": 2,
        "reverse": true,
        "labelGradient": "from-green-400 to-cyan-400",
        "blobGradient": "from-green-500/30 via-cyan-500/25 to-blue-500/20",
        "image": "https://readdy.ai/api/search-image?query=calendar%20resource%20settings%20dashboard%20minimal%20dark%20interface%20meeting%20rooms%20equipment%20booking%20UI&width=1200&height=700&seq=bookerstep002&orientation=landscape"
      },
      {
        "num": "03",
        "title": "Бронируйте прямо из сделки",
        "desc": "Откройте любую сделку, нажмите на виджет и выберите нужный ресурс и время. Бронирование создаётся мгновенно.",
        "icon": "ri-calendar-check-line",
        "step": 3,
        "reverse": false,
        "labelGradient": "from-violet-500 to-pink-400",
        "blobGradient": "from-violet-500/30 via-pink-500/25 to-yellow-500/20",
        "image": "https://readdy.ai/api/search-image?query=deal%20card%20calendar%20booking%20widget%20inside%20CRM%20minimal%20dark%20interface%20modern%20UI&width=1200&height=700&seq=bookerstep003&orientation=landscape"
      }
    ]
  },
  "pricing": {
    "badge": "Тарифы",
    "title": "Выберите подходящий план",
    "subtitle": "Все тарифы включают 14-дневный бесплатный период",
    "toggle": {
      "monthly": "Ежемесячно",
      "yearly": "Ежегодно",
      "discount": "−20%"
    },
    "popularLabel": "ПОПУЛЯРНЫЙ",
    "period": "/мес",
    "plans": [
      {
        "name": "Старт",
        "price": {
          "monthly": "990",
          "yearly": "790"
        },
        "desc": "Для небольших команд",
        "features": [
          "До 5 пользователей",
          "До 3 ресурсов",
          "Базовый календарь",
          "Email-уведомления",
          "Поддержка по email"
        ],
        "cta": "Начать бесплатно",
        "highlight": false
      },
      {
        "name": "Бизнес",
        "price": {
          "monthly": "2 490",
          "yearly": "1 990"
        },
        "desc": "Для растущих компаний",
        "features": [
          "До 25 пользователей",
          "Неограниченные ресурсы",
          "Drag-and-drop календарь",
          "SMS и push-уведомления",
          "Аналитика загрузки",
          "Приоритетная поддержка"
        ],
        "cta": "Попробовать 14 дней",
        "highlight": true
      },
      {
        "name": "Корпоратив",
        "price": {
          "monthly": "5 990",
          "yearly": "4 990"
        },
        "desc": "Для крупных организаций",
        "features": [
          "Неограниченные пользователи",
          "Неограниченные ресурсы",
          "Кастомные правила брони",
          "API-интеграции",
          "Выделенный менеджер",
          "SLA 99.9%"
        ],
        "cta": "Связаться с нами",
        "highlight": false
      }
    ]
  },
  "faq": {
    "badge": "FAQ",
    "title": "Частые вопросы",
    "subtitle": "Не нашли ответ? Напишите нам в чат",
    "items": [
      {
        "q": "Нужны ли технические знания для установки?",
        "a": "Нет. Установка виджета занимает 5 минут и не требует разработчиков. Вы просто находите БроньСРМ в маркетплейсе amoCRM и нажимаете «Установить». Всё остальное настраивается через удобный интерфейс.",
        "gradient": "from-yellow-400 to-red-400"
      },
      {
        "q": "Работает ли сервис с любой версией amoCRM?",
        "a": "БроньСРМ совместим со всеми актуальными версиями amoCRM, включая базовый, расширенный и профессиональный тарифы. Для работы виджета необходим доступ к API amoCRM.",
        "gradient": "from-green-400 to-cyan-400"
      },
      {
        "q": "Можно ли бронировать ресурсы для внешних клиентов?",
        "a": "Да! Вы можете создать публичную страницу бронирования и отправить ссылку клиенту. Клиент выбирает удобное время, а бронирование автоматически появляется в amoCRM и привязывается к нужной сделке.",
        "gradient": "from-violet-500 to-pink-400"
      },
      {
        "q": "Как происходит оплата?",
        "a": "Оплата производится ежемесячно или ежегодно (со скидкой 20%) банковской картой или по счёту для юридических лиц. Первые 14 дней — бесплатно, без привязки карты.",
        "gradient": "from-cyan-400 to-violet-500"
      },
      {
        "q": "Что происходит с данными при отмене подписки?",
        "a": "Все ваши данные хранятся 30 дней после отмены подписки. В течение этого времени вы можете экспортировать историю бронирований в CSV или Excel. После 30 дней данные удаляются безвозвратно.",
        "gradient": "from-red-400 to-yellow-400"
      },
      {
        "q": "Есть ли мобильное приложение?",
        "a": "БроньСРМ полностью адаптирован для мобильных устройств и работает через браузер. Отдельное приложение не требуется — виджет доступен в мобильной версии amoCRM.",
        "gradient": "from-green-400 to-yellow-400"
      }
    ]
  },
  "contact": {
    "badge": "Контакты",
    "title": "Готовы начать **работу?**",
    "text": "Оставьте заявку и мы свяжемся с вами в течение 30 минут. Покажем демо и ответим на все вопросы.",
    "info": [
      {
        "icon": "ri-mail-line",
        "text": "amo@vnedrim-crm.ru",
        "gradient": "from-yellow-400 to-red-400",
        "href": "mailto:amo@vnedrim-crm.ru"
      },
      {
        "icon": "ri-phone-line",
        "text": "+7 (977) 421-79-97",
        "gradient": "from-green-400 to-cyan-400",
        "href": "tel:+79774217997"
      },
      {
        "icon": "ri-time-line",
        "text": "Пн–Пт, 9:00–18:00 МСК",
        "gradient": "from-violet-400 to-pink-400"
      }
    ],
    "form": {
      "fields": {
        "name": "Имя",
        "namePlaceholder": "Иван Иванов",
        "email": "Email",
        "emailPlaceholder": "ivan@company.ru",
        "phone": "Телефон",
        "phonePlaceholder": "+7 (___) ___-__-__",
        "company": "Компания и сфера деятельности",
        "companyPlaceholder": "ООО Ромашка, продажа недвижимости",
        "message": "Сообщение",
        "messagePlaceholder": "Расскажите о вашей задаче..."
      },
      "submitLabel": "Получить бесплатный доступ",
      "submittingLabel": "Отправляем...",
      "errors": {
        "tooLong": "Сообщение не должно превышать 500 символов",
        "generic": "Не удалось отправить заявку. Попробуйте ещё раз.",
        "success": "Заявка отправлена! Мы свяжемся с вами в течение 30 минут"
      }
    }
  },
  "footer": {
    "brandText": "Бронирование встреч, переговорных и инвентаря прямо в amoCRM. Установка за 5 минут, работа с первого дня.",
    "columns": [
      {
        "title": "Продукт",
        "links": [
          {
            "text": "Возможности",
            "href": "#"
          },
          {
            "text": "Тарифы",
            "href": "#"
          },
          {
            "text": "Интеграции",
            "href": "#"
          },
          {
            "text": "Обновления",
            "href": "#"
          }
        ]
      },
      {
        "title": "Компания",
        "links": [
          {
            "text": "О нас",
            "href": "#"
          },
          {
            "text": "Блог",
            "href": "#"
          },
          {
            "text": "Карьера",
            "href": "#"
          },
          {
            "text": "Партнёрам",
            "href": "#"
          }
        ]
      },
      {
        "title": "Поддержка",
        "links": [
          {
            "text": "Документация",
            "href": "#"
          },
          {
            "text": "FAQ",
            "href": "#"
          },
          {
            "text": "Статус сервиса",
            "href": "#"
          },
          {
            "text": "Контакты",
            "href": "#"
          }
        ]
      }
    ],
    "copyright": "© 2026 Быстренко.ру. Все права защищены."
  }
}
